import AuthCookie from './AuthCookie';

class BaseRest {
  getPath(path) {
    let url = this.url;
    if (path) {
      if (path.charAt(0) !== '/') {
        url = url + '/';
      }
      url = url + path;
    }
    return fetch(url, this.buildOptions('GET'));
  }

  get(path, query) {
    return fetch(this.buildUrl(path, query), this.buildOptions('GET'));
  }

  post(path, requestBody) {
    return fetch(this.buildUrl(path), this.buildOptions('POST', requestBody));
  }

  put(path, requestBody) {
    return fetch(this.buildUrl(path), this.buildOptions('PUT', requestBody));
  }

  buildOptions(method, body) {
    let token = AuthCookie.getToken();

    let options = {
      credentials: 'same-origin',
      method: method,
      headers: { 'content-type': 'application/json' }
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    if (token) {
      options.headers.Authorization = `Bearer ${token}`;
    }
    return options;
  }

  buildUrl(path, query) {
    let url = this.url;
    if (this.path) {
      if (this.path.charAt(0) !== '/') {
        url = url + '/';
      }
      url = url + this.path;
    }
    if (path) {
      if (path.charAt(0) !== '/') {
        url = url + '/';
      }
      url = url + path;
    }
    if (query) {
      if (query.charAt(0) !== '?') {
        url = url + '?';
      }
      url = url + query;
    }
    return url;
  }
}

export default BaseRest;



// WEBPACK FOOTER //
// ./src/api/BaseRest.js